import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Plan } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2300. 契約プラン一覧
 * [GET] /workspaces/:identifier/plans
 */
const plans = (): Promise<Plan[]> => {
  return axios.get(`/api/plans`, {});
};

export const usePlans = () => {
  return useQuery({
    queryKey: ['plans'],
    queryFn: () => plans(),
  });
};
